class MobileAnnouncementSlider extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
    this.slides = [];
    this.interval = null;
  }

  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.mobile-slider__slide'));
    
    if (this.slides.length > 0) {
      this.startAutoplay();
    }
  }

  disconnectedCallback() {
    this.stopAutoplay();
  }

  startAutoplay() {
    const delay = parseInt(this.getAttribute('delay') || '3000', 10);
    
    this.interval = setInterval(() => {
      this.nextSlide();
    }, delay);
  }

  stopAutoplay() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  nextSlide() {
    this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    this.updateSlides();
  }

  updateSlides() {
    const offset = -this.currentIndex * 100;
    const track = this.querySelector('.mobile-slider__track');
    
    if (track) {
      track.style.transform = `translateX(${offset}%)`;
    }
  }
}

customElements.define('mobile-announcement-slider', MobileAnnouncementSlider);

